import React from 'react';
import { Bell, Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Topbar({ title, notificationCount = 0, onMenuToggle }) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'fr';

  return (
    <div className="h-14 bg-white border-b border-slate-200 sticky top-0 z-20 flex items-center px-4 lg:px-6 gap-2 lg:gap-4">
      {/* Hamburger — mobile only */}
      <button
        onClick={onMenuToggle}
        className="lg:hidden w-8 h-8 grid place-items-center text-slate-500 hover:bg-slate-100 rounded-md transition flex-shrink-0"
      >
        <Menu size={18} strokeWidth={1.75} />
      </button>

      {/* Title */}
      <div className="flex-shrink-0">
        {title && <div className="text-[14px] font-semibold tracking-tight text-slate-900">{title}</div>}
      </div>

      <div className="flex-1" />

      {/* Right */}
      <div className="flex items-center gap-2">
        {/* Language switcher */}
        <div className="flex items-center rounded-md border border-slate-200 overflow-hidden text-[11px] font-semibold">
          {['fr', 'en'].map((l) => (
            <button
              key={l}
              onClick={() => i18n.changeLanguage(l)}
              className={`px-2.5 h-7 transition ${
                lang === l
                  ? 'bg-primary text-white'
                  : 'text-slate-500 hover:bg-slate-50'
              }`}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>

        <button className="relative w-8 h-8 grid place-items-center text-slate-500 hover:bg-slate-100 rounded-md transition">
          <Bell size={16} strokeWidth={1.75} />
          {notificationCount > 0 && (
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-accent ring-2 ring-white" />
          )}
        </button>
      </div>
    </div>
  );
}

export default Topbar;
